<!-- penalty -->
<template>
  <div class="penalty">
    <div>
      <div>
        <div class="penalty-title">
          <zlr-title title="Penalty Records"></zlr-title>
        </div>
        <Form ref="formValidate" :model="formValidate" :rules="ruleValidate">
          <ul class="penalty-search-con">
            <li>
              <FormItem label="Type">
                <Select
                  v-model="formValidate.type"
                  placeholder="Select"
                  clearable
                >
                  <Option
                    v-for="item in penaltyTypeMap"
                    :key="item[0]"
                    :value="item[0]"
                    >{{ item[1] }}</Option
                  >
                </Select>
              </FormItem>
            </li>
            <li>
              <FormItem label="Mentee">
                <Select
                  v-model="formValidate.menteeNum"
                  placeholder="Select"
                  clearable
                >
                  <Option
                    v-for="(item, index) in menteeList"
                    :key="index"
                    :value="item.menteeNum"
                    >{{ item.menteeEnName }}</Option
                  >
                </Select>
              </FormItem>
            </li>
            <li>
              <FormItem label="Status">
                <Select
                  v-model="formValidate.status"
                  placeholder="Select"
                  clearable
                >
                  <Option
                    v-for="item in penaltyStatusMap"
                    :key="item[0]"
                    :value="item[0]"
                    >{{ item[1] }}</Option
                  >
                </Select>
              </FormItem>
            </li>
            <li>
              <FormItem label="Module">
                <Select
                  v-model="formValidate.module"
                  placeholder="Select"
                  clearable
                >
                  <Option
                    v-for="item in penaltyModuleMap"
                    :key="item[0]"
                    :value="item[0]"
                    >{{ item[1] }}</Option
                  >
                </Select>
              </FormItem>
            </li>
            <li>
              <Button class="zlr-btn-default" @click="handleSearch"
                >Search</Button
              >
            </li>
          </ul>
        </Form>
        <template v-if="tableData.length">
          <Table
            :columns="columnsData"
            :data="tableData"
            :row-class-name="rowClassName"
            @on-row-click="clickRow"
          ></Table>
          <!--提示语-->
          <div class="penalty-warning">
            If you believe that you are erroneously receiving the penalty above,
            you may dispute the specific record that status is unexecuted by
            replying to the related email sent by mentorpenalty@zlrvaleon.com.
          </div>
          <div class="penalty-page">
            <Page
              :total="totalItems"
              :page-size="pageSize"
              :current="currentPage"
              @on-change="handlePageChange"
            ></Page>
          </div>
        </template>
        <zlr-empty v-else></zlr-empty>
      </div>
      <!--详情-->
      <zlr-modal v-model="penaltyModal" style="width: 100%;min-width: 660px;">
        <div class="penalty-desc" name="slot">
          <div class="penalty-desc-detail">
            <div
              class="penalty-detail-info"
              v-if="penaltyInfo.source === 'MANUAL'"
            >
              <h3>Appointment Info</h3>
              <div class="penalty-detail-item">
                <div class="penalty-detail-name">Appointment Time：</div>
                <div class="penalty-detail-val">
                  {{ penaltyInfo.appointmentTime }}
                </div>
              </div>
            </div>
            <div
              class="penalty-detail-info"
              v-if="
                penaltyInfo.source === 'SYSTEM' &&
                  penaltyInfo.type !== 'MISSED_ESSAY_TURNAROUND_TIME'
              "
            >
              <h3>Appointment Info</h3>
              <div class="penalty-detail-item">
                <div class="penalty-detail-name">Appointment Time：</div>
                <div class="penalty-detail-val">
                  {{ penaltyInfo.appointmentTimeStr }}
                </div>
              </div>
            </div>
            <div
              class="penalty-detail-info"
              v-if="
                penaltyInfo.source === 'SYSTEM' &&
                  penaltyInfo.type === 'MISSED_ESSAY_TURNAROUND_TIME'
              "
            >
              <h3>Material Info</h3>
              <div class="penalty-detail-item">
                <div class="penalty-detail-name">MaterialType：</div>
                <div class="penalty-detail-val">
                  {{ penaltyInfo.materialType }}
                </div>
              </div>
              <div class="penalty-detail-item">
                <div class="penalty-detail-name">Univer：</div>
                <div class="penalty-detail-val">
                  {{ penaltyInfo.univer }}
                </div>
              </div>
              <div class="penalty-detail-item">
                <div class="penalty-detail-name">Program：</div>
                <div class="penalty-detail-val">
                  {{ penaltyInfo.program }}
                </div>
              </div>
              <div class="penalty-detail-item">
                <div class="penalty-detail-name">Title：</div>
                <div class="penalty-detail-val">
                  {{ penaltyInfo.title }}
                </div>
              </div>
              <div class="penalty-detail-item">
                <div class="penalty-detail-name">Turnaround DDL：</div>
                <div class="penalty-detail-val">
                  {{ penaltyInfo.returnTime }}
                </div>
              </div>
            </div>
          </div>
          <div class="penalty-btn">
            <Button class="zlr-btn-default" @click="penaltyModal = false"
              >Close</Button
            >
          </div>
        </div>
      </zlr-modal>
    </div>
  </div>
</template>

<script>
// api
import penaltyService from '@/api/penalty'
// less
import './index.less'
// components
import ZlrTitle from '_c/title/title'
import ZlrEmpty from '_c/empty/empty'
// mixins
import mixinsPage from '@/view/mixins/page'
import { mapState } from 'vuex'
import {
  penaltyStatusMap,
  penaltyTypeMap,
  penaltyModuleMap
} from './constantEnum'
import ZlrModal from '../../../components/modal/modal'

export default {
  name: 'penalty',
  mixins: [mixinsPage],
  components: {
    ZlrTitle,
    ZlrEmpty,
    ZlrModal
  },
  data() {
    return {
      // status映射
      penaltyStatusMap,
      // type映射
      penaltyTypeMap,
      // module映射
      penaltyModuleMap,
      formValidate: {},
      ruleValidate: {},
      columnsData: [
        {
          title: 'Type',
          key: 'type',
          align: 'center',
          width: 240,
          render(h, params) {
            let data = params.row.type
            let val = ''
            if (data) {
              val = new Map(penaltyTypeMap).get(data)
            }
            return h('div', val)
          }
        },
        {
          title: 'Mentee name',
          key: 'menteeName',
          align: 'center',
          width: 180
        },
        {
          title: 'Module',
          key: 'module',
          align: 'center',
          width: 160,
          render(h, params) {
            let data = params.row.module
            let val = ''
            if (data) {
              val = new Map(penaltyModuleMap).get(data)
            }
            return h('div', val)
          }
        },
        {
          title: 'Status',
          key: 'status',
          align: 'center',
          width: 200,
          render(h, params) {
            let data = params.row.status
            let val = ''
            if (data) {
              val = new Map(penaltyStatusMap).get(data)
            }
            return h('div', val)
          }
        },
        {
          title: 'CreateTime',
          key: 'createTime',
          align: 'center',
          width: 160
        },
        {
          title: '--'
        }
      ],
      tableData: [],
      // 详情弹窗标识
      penaltyModal: false,
      // 详情信息
      penaltyInfo: {}
    }
  },
  computed: {
    ...mapState({
      menteeList(state) {
        return state.mentee.menteeList
      }
    })
  },
  mounted() {
    this.getPageList()
  },
  methods: {
    // 行可点击样式
    rowClassName: (row, index) => {
      return 'hasCursor'
    },
    // 换行过滤
    lineFilter(value) {
      if (value) {
        let result = value
        for (let i = 0; i < result.length; i++) {
          result = result.replace(/\n/g, '<br/>').replace(/\r/g, '<br/>')
        }
        return result
      }
    },
    // 获取数据
    getPageList() {
      let data = {
        ...this.formValidate,
        currentPage: this.currentPage - 1,
        pageSize: this.pageSize
      }
      penaltyService
        .getPenaltyPage(data)
        .then(res => {
          let page = res.data.page
          this.tableData = page.result
          this.totalItems = page.totalItems
        })
        .catch(() => {
          this.tableData = []
          this.totalItems = 0
          this.pageSize = 1
        })
    },
    // 行点击事件-查看详情
    clickRow(row) {
      penaltyService
        .getPenaltyDetail({ id: row.id })
        .then(res => {
          this.penaltyInfo = res.data.model || {}
          this.penaltyModal = true
        })
        .catch(error => {
          this.$zlr_message(error.message, 'error')
        })
    }
  }
}
</script>
<style lang="less" scoped></style>
<style lang="less">
.penalty .ivu-table .hasCursor {
  cursor: pointer;
}
.penalty-warning {
  padding: 20px 20px 0;
  color: #999;
}
.penalty-desc {
  width: 600px;
  padding: 0 20px;
  .penalty-detail-info {
    padding: 20px 0;
    .penalty-detail-item {
      display: flex;
      line-height: 36px;
      .penalty-detail-name {
        flex: 0 0 200px;
      }
      .penalty-detail-val {
        flex: 1;
      }
    }
    .penalty-btn {
      text-align: center;
    }
  }
}
</style>
